module.exports = __webpack_public_path__ + "static/media/FiDisabled.a2935f07.svg";